import './driverSummary.css';
import {driverSummary} from "../../../data/driversData";

const DriversSummary = ({summary}) => {
    const summaryContent = summary ?? driverSummary;
    return (
        <ul className={'driver-summary grid gap-0'}>
            {
                summaryContent.map((item, index) =>
                    <li key={index} className="">
                        <div className={`number ${item?.color} ${index > 1 ? 'sf-medium' : 'sf-bold'}`}>{item?.text}</div>
                        <div className="name sf-medium">{item?.name}</div>
                    </li>
                )
            }

        </ul>
    )
}

export default DriversSummary;
